module.exports = __webpack_public_path__ + "static/media/14UNEP13.972c547c.jpg";